import axios from 'axios';

export async function getImageDensities(image, width) {
  return await axios
    .patch(route('service.image'), { image, width })
    .then(data => {
      return data.data;
    })
    .catch(e => {
      return null;
    });
}
